import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, makeStyles, Theme } from '@material-ui/core'
import { tr } from 'utils/translations/translate'
import Typography from '@material-ui/core/Typography'
import {
    TEXT_DELETE_INVOICES_DIALOG_CONFIRM,
    TEXT_DELETE_INVOICES_DIALOG_TEXT_1,
    TEXT_DELETE_INVOICES_DIALOG_TEXT_2,
    TEXT_DELETE_INVOICES_DIALOG_TITLE,
} from 'utils/translations/keys'

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        paddingBottom: '0',
    },
    titleCase: {
        textTransform: 'capitalize',
    },
}))

type DeleteInvoiceDialogProps = {
    open: boolean
    handleOk: () => void
    handleClose: () => void
}
export const DeleteInvoiceDialog: React.FC<DeleteInvoiceDialogProps> = (props) => {
    const { open, handleClose, handleOk } = props
    const styles = useStyles()

    return (
        <Dialog open={open}>
            <DialogTitle className={styles.dialogTitle}>{tr(TEXT_DELETE_INVOICES_DIALOG_TITLE)}</DialogTitle>
            <DialogContent>
                <Typography>{tr(TEXT_DELETE_INVOICES_DIALOG_TEXT_1)}</Typography>

                <Typography>{tr(TEXT_DELETE_INVOICES_DIALOG_TEXT_2)}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {tr('TEXT_CANCEL')}
                </Button>
                <Button onClick={() => handleOk()} variant="contained" color="primary" autoFocus>
                    {tr(TEXT_DELETE_INVOICES_DIALOG_CONFIRM)}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
